var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8143 1.26518L13.8141 1.265C13.6117 1.06327 13.3378 0.95 13.0522 0.95C12.7667 0.95 12.4927 1.06327 12.2903 1.265L12.2903 1.26507L1.93387 11.6248L1.92374 11.635L1.92051 11.6489L0.974949 15.737L0.974945 15.737L0.974813 15.7376C0.940608 15.8943 0.941781 16.0567 0.978244 16.2129C1.01471 16.369 1.08554 16.5151 1.18558 16.6404C1.28562 16.7657 1.41233 16.867 1.55647 16.9369C1.6999 17.0065 1.85696 17.0433 2.01631 17.0446C2.09003 17.0519 2.16431 17.0518 2.23802 17.0443L2.23806 17.0447L2.24418 17.0433L6.36982 16.0961L6.38384 16.0929L6.394 16.0827L16.7355 5.73292L16.7356 5.73281C16.937 5.53006 17.05 5.25569 17.05 4.9697C17.05 4.68372 16.937 4.40935 16.7356 4.2066L13.8143 1.26518ZM13.5389 7.42246L5.83616 15.1041L2.06052 15.8976L2.92045 12.189L10.6236 4.50198L13.5389 7.42246ZM14.2761 6.62847L11.3612 3.70849L13.022 2.05439L15.8886 4.97481L14.2761 6.62847Z",
    fill: "#4B4B4B",
    stroke: "black",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6507248bb882a5f186092f1faeb67bc9.svg";
export { ForwardRef as ReactComponent };